import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "gso44t-0"
})(["position:relative;"]);
export default Container;